import UpArrowIcon from './UpArrowIcon'

export default UpArrowIcon
